import React from 'react'
import MemberkitLogoPng from '../images/memberkit.png'

const MemberKitPng = () => {
  return <img src={MemberkitLogoPng} alt="Memberkit Logo" />
}

export { MemberKitPng }
